module.exports = __webpack_public_path__ + "static/media/polygon.f42983b3.svg";